// extracted by mini-css-extract-plugin
export default {"main":"GridItem_main__T5RB5","gridIcon":"GridItem_gridIcon__L2IfF","gridTitle":"GridItem_gridTitle__G0MIF","gridInfo":"GridItem_gridInfo__acpZq","yourImc":"GridItem_yourImc__eZADv"};